import TYPES from '../../types';
import Injectable from '@/modules/shared/domain/dependency_injection/injectable';
import Inject from '@/modules/shared/domain/dependency_injection/inject';
import Query from '@/modules/shared/domain/services/query';
import { StateManager } from '../../domain/state/state-manager';
import { CountryRepository } from '../../domain/repository/country-repository';
import { CountryEntity } from '../../domain/entities/country-entity';

@Injectable()
export default class GetCountriesQueryService extends Query<Promise<Array<CountryEntity>>> {
  @Inject(TYPES.ONBOARDING_CATALOG_COUNTRY_STATE_MANAGER)
  private readonly state_manager!: StateManager;

  @Inject(TYPES.COUNTRY_REPOSITORY)
  private readonly repository!: CountryRepository;

  internalExecute(): Promise<Array<CountryEntity>> {
    return new Promise((resolve, reject) => {
      if (this.state_manager.state.items.length < 2) {
        this.repository.findAll()
          .then((items) => {
            this.state_manager.patch({ items });
            resolve(items);
          })
          .catch(reject);
      } else {
        resolve(this.state_manager.state.items);
      }
    });
  }
}
